module.exports = __webpack_public_path__ + "static/media/Trinidad and Tobago.df2123aa.png";